import TransactionConfirmationLoader from './TransactionConfirmationLoader'

export default TransactionConfirmationLoader